webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(12)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(7),
  /* template */
  __webpack_require__(16),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 5 */,
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_circle_slider__ = __webpack_require__(3);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_circle_slider__["default"]);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].directive('hljs', {
  inserted: function inserted(el) {
    window.hljs.highlightBlock(el);
  }
});

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Hello__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Hello___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Hello__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    Hello: __WEBPACK_IMPORTED_MODULE_0__components_Hello___default.a
  }
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    title: {
      type: String,
      required: true
    },
    fiddlelink: {
      type: String,
      required: false
    },
    desc: {
      type: String,
      required: false,
      default: null
    },
    snippet: {
      type: String,
      required: true
    }
  }
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Example_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Example_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Example_vue__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'hello',
  components: {
    Example: __WEBPACK_IMPORTED_MODULE_0__Example_vue___default.a
  },
  data: function data() {
    return {
      val1: 30,
      val2: 2000,
      val3: 75,
      val4: 50,
      val5: 50,
      val6: 25,
      val7: 10,

      exs: {
        ex1: {
          title: 'Default',
          desc: 'Usage without any props',
          fiddlelink: 'https://jsfiddle.net/alexx_l/88h9qp7b/',
          snippet: '          <circle-slider v-model="val1"></circle-slider>\n\n          <div>{{ val1 }}</div>'
        },
        ex2: {
          title: 'Custom dimension',
          desc: 'Custom min/max values and step size',
          fiddlelink: 'https://jsfiddle.net/alexx_l/5mfyd1sp/2/',
          snippet: '          <circle-slider\n            v-model="val2"\n            :min="0"\n            :max="10000"\n            :step-size="100"\n          ></circle-slider>\n\n          <div>{{ val2 }}</div>'
        },
        ex3: {
          title: 'Custom side',
          desc: 'Exact size of svg square side (in px)',
          fiddlelink: 'https://jsfiddle.net/alexx_l/t1asf075/',
          snippet: '          <circle-slider :side="150" v-model="val3"></circle-slider>\n          <circle-slider :side="50" v-model="val3"></circle-slider>\n\n          <div>{{ val3 }}</div>'
        },
        ex4: {
          title: 'Exact sizes',
          desc: 'Custom circumference and progress curve width, custom knob radius',
          fiddlelink: 'https://jsfiddle.net/alexx_l/fL5ojhtz/',
          snippet: '          <circle-slider\n            v-model="val4"\n            :circle-width="8"\n            :progress-width="12"\n            :knob-radius="10"\n          ></circle-slider>\n\n          <circle-slider\n            v-model="val4"\n            :circle-width="10"\n            :progress-width="5"\n            :knob-radius="10"\n          ></circle-slider>\n\n          <circle-slider\n            v-model="val4"\n            :circle-width="12"\n            :progress-width="3"\n            :knob-radius="4"\n          ></circle-slider>\n\n          <div>{{ val4 }}</div>'
        },
        ex5: {
          title: 'Relative sizes',
          desc: 'Custom relative circumference and progress curve width, custom relative knob radius.<br />See params <b>knobRadiusRel</b>, <b>circleWidthRel</b> and <b>progressWidthRel</b> in <a href="https://github.com/devstark-com/vue-circle-slider#props" target="_blank">docs</a>',
          fiddlelink: 'https://jsfiddle.net/alexx_l/qfbnzgy5/',
          snippet: '          <circle-slider\n            v-model="val5"\n            :circle-width-rel="30"\n            :progress-width-rel="15"\n            :knob-radius-rel="8"\n          ></circle-slider>\n\n          <div>{{ val5 }}</div>'
        },
        ex6: {
          title: 'Colors',
          desc: 'Custom color for circle, progress and knob',
          fiddlelink: 'https://jsfiddle.net/alexx_l/abvf9joh/',
          snippet: '          <circle-slider\n            v-model="val6"\n            circle-color="#edeff0"\n            progress-color="#cecece"\n            knob-color="#a0a0ff"\n          ></circle-slider>\n\n          <circle-slider\n            v-model="val6"\n            circle-color="#f00"\n            progress-color="#0a0"\n            knob-color="#0c0"\n          ></circle-slider>\n\n          <circle-slider\n            v-model="val6"\n            circle-color="#cecece"\n            progress-color="#00f"\n            knob-color="#5555ff"\n          ></circle-slider>\n\n          <div>{{ val6 }}</div>'
        },
        ex7: {
          title: 'Two-way binding',
          desc: 'Two way binding with input field',
          fiddlelink: 'https://jsfiddle.net/alexx_l/ake02cro/',
          snippet: '          <circle-slider\n            v-model="val7"\n            @touchmove="$refs.input.blur()"\n          ></circle-slider>\n          <!-- @touchmove="$refs.input.blur()" - hide keyboard on touchmove at mobile devices -->\n\n          <input ref="input" type="number" v-model.number="val7" />'
        }
      }
    };
  }
});

/***/ }),
/* 10 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 11 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 12 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(8),
  /* template */
  __webpack_require__(17),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(11)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(9),
  /* template */
  __webpack_require__(15),
  /* scopeId */
  "data-v-2b1052fc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 15 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('example', {
    attrs: {
      "title": _vm.exs.ex1.title,
      "desc": _vm.exs.ex1.desc,
      "fiddlelink": _vm.exs.ex1.fiddlelink,
      "snippet": _vm.exs.ex1.snippet
    }
  }, [_c('circle-slider', {
    model: {
      value: (_vm.val1),
      callback: function($$v) {
        _vm.val1 = $$v
      },
      expression: "val1"
    }
  }), _vm._v(" "), _c('div', {
    slot: "external"
  }, [_vm._v(_vm._s(_vm.val1))])], 1), _vm._v(" "), _c('example', {
    attrs: {
      "title": _vm.exs.ex2.title,
      "desc": _vm.exs.ex2.desc,
      "fiddlelink": _vm.exs.ex2.fiddlelink,
      "snippet": _vm.exs.ex2.snippet
    }
  }, [_c('circle-slider', {
    attrs: {
      "min": 0,
      "max": 10000,
      "stepSize": 100
    },
    model: {
      value: (_vm.val2),
      callback: function($$v) {
        _vm.val2 = $$v
      },
      expression: "val2"
    }
  }), _vm._v(" "), _c('div', {
    slot: "external"
  }, [_vm._v(_vm._s(_vm.val2))])], 1), _vm._v(" "), _c('example', {
    attrs: {
      "title": _vm.exs.ex3.title,
      "desc": _vm.exs.ex3.desc,
      "fiddlelink": _vm.exs.ex3.fiddlelink,
      "snippet": _vm.exs.ex3.snippet
    }
  }, [_c('circle-slider', {
    attrs: {
      "side": 150
    },
    model: {
      value: (_vm.val3),
      callback: function($$v) {
        _vm.val3 = $$v
      },
      expression: "val3"
    }
  }), _vm._v(" "), _c('circle-slider', {
    attrs: {
      "side": 50
    },
    model: {
      value: (_vm.val3),
      callback: function($$v) {
        _vm.val3 = $$v
      },
      expression: "val3"
    }
  }), _vm._v(" "), _c('div', {
    slot: "external"
  }, [_vm._v(_vm._s(_vm.val3))])], 1), _vm._v(" "), _c('example', {
    attrs: {
      "title": _vm.exs.ex4.title,
      "desc": _vm.exs.ex4.desc,
      "fiddlelink": _vm.exs.ex4.fiddlelink,
      "snippet": _vm.exs.ex4.snippet
    }
  }, [_c('circle-slider', {
    attrs: {
      "circle-width": 8,
      "progress-width": 12,
      "knob-radius": 10
    },
    model: {
      value: (_vm.val4),
      callback: function($$v) {
        _vm.val4 = $$v
      },
      expression: "val4"
    }
  }), _vm._v(" "), _c('circle-slider', {
    attrs: {
      "circle-width": 10,
      "progress-width": 5,
      "knob-radius": 10
    },
    model: {
      value: (_vm.val4),
      callback: function($$v) {
        _vm.val4 = $$v
      },
      expression: "val4"
    }
  }), _vm._v(" "), _c('circle-slider', {
    attrs: {
      "circle-width": 12,
      "progress-width": 3,
      "knob-radius": 4
    },
    model: {
      value: (_vm.val4),
      callback: function($$v) {
        _vm.val4 = $$v
      },
      expression: "val4"
    }
  }), _vm._v(" "), _c('div', {
    slot: "external"
  }, [_vm._v(_vm._s(_vm.val4))])], 1), _vm._v(" "), _c('example', {
    attrs: {
      "title": _vm.exs.ex5.title,
      "desc": _vm.exs.ex5.desc,
      "fiddlelink": _vm.exs.ex5.fiddlelink,
      "snippet": _vm.exs.ex5.snippet
    }
  }, [_c('circle-slider', {
    attrs: {
      "circle-width-rel": 30,
      "progress-width-rel": 15,
      "knob-radius-rel": 8
    },
    model: {
      value: (_vm.val5),
      callback: function($$v) {
        _vm.val5 = $$v
      },
      expression: "val5"
    }
  }), _vm._v(" "), _c('div', {
    slot: "external"
  }, [_vm._v(_vm._s(_vm.val5))])], 1), _vm._v(" "), _c('example', {
    attrs: {
      "title": _vm.exs.ex6.title,
      "desc": _vm.exs.ex6.desc,
      "fiddlelink": _vm.exs.ex6.fiddlelink,
      "snippet": _vm.exs.ex6.snippet
    }
  }, [_c('circle-slider', {
    attrs: {
      "circle-color": "#edeff0",
      "progress-color": "#cecece",
      "knob-color": "#a0a0ff"
    },
    model: {
      value: (_vm.val6),
      callback: function($$v) {
        _vm.val6 = $$v
      },
      expression: "val6"
    }
  }), _vm._v(" "), _c('circle-slider', {
    attrs: {
      "circle-color": "#f00",
      "progress-color": "#0a0",
      "knob-color": "#0c0"
    },
    model: {
      value: (_vm.val6),
      callback: function($$v) {
        _vm.val6 = $$v
      },
      expression: "val6"
    }
  }), _vm._v(" "), _c('circle-slider', {
    attrs: {
      "circle-color": "#cecece",
      "progress-color": "#00f",
      "knob-color": "#5555ff"
    },
    model: {
      value: (_vm.val6),
      callback: function($$v) {
        _vm.val6 = $$v
      },
      expression: "val6"
    }
  }), _vm._v(" "), _c('div', {
    slot: "external"
  }, [_vm._v(_vm._s(_vm.val6))])], 1), _vm._v(" "), _c('example', {
    attrs: {
      "title": _vm.exs.ex7.title,
      "desc": _vm.exs.ex7.desc,
      "fiddlelink": _vm.exs.ex7.fiddlelink,
      "snippet": _vm.exs.ex7.snippet
    }
  }, [_c('circle-slider', {
    on: {
      "touchmove": function($event) {
        _vm.$refs.input.blur()
      }
    },
    model: {
      value: (_vm.val7),
      callback: function($$v) {
        _vm.val7 = $$v
      },
      expression: "val7"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.val7),
      expression: "val7",
      modifiers: {
        "number": true
      }
    }],
    ref: "input",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.val7)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.val7 = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })], 1)], 1)]), _vm._v(" "), _vm._m(2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('h1', [_vm._v("vue-circle-slider demo")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "https://vuejs.org",
      "target": "_blank"
    }
  }, [_vm._v("Vue.js docs")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/devstark-com/vue-circle-slider",
      "target": "_blank"
    }
  }, [_vm._v("Plugin repo")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/devstark-com/vue-circle-slider-demo",
      "target": "_blank"
    }
  }, [_vm._v("This demo repo")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "nav-sidebar"
  }, [_c('h3', [_vm._v("Examples")]), _vm._v(" "), _c('div', {
    staticClass: "list-group"
  }, [_c('a', {
    staticClass: "list-group-item",
    attrs: {
      "href": "#Default"
    }
  }, [_vm._v("Default")]), _vm._v(" "), _c('a', {
    staticClass: "list-group-item",
    attrs: {
      "href": "#Custom dimension"
    }
  }, [_vm._v("Custom dimension")]), _vm._v(" "), _c('a', {
    staticClass: "list-group-item",
    attrs: {
      "href": "#Custom side"
    }
  }, [_vm._v("Custom side")]), _vm._v(" "), _c('a', {
    staticClass: "list-group-item",
    attrs: {
      "href": "#Exact sizes"
    }
  }, [_vm._v("Exact sizes")]), _vm._v(" "), _c('a', {
    staticClass: "list-group-item",
    attrs: {
      "href": "#Relative sizes"
    }
  }, [_vm._v("Relative sizes")]), _vm._v(" "), _c('a', {
    staticClass: "list-group-item",
    attrs: {
      "href": "#Colors"
    }
  }, [_vm._v("Colors")]), _vm._v(" "), _c('a', {
    staticClass: "list-group-item",
    attrs: {
      "href": "#Two-way binding"
    }
  }, [_vm._v("Two-way binding")])]), _vm._v(" "), _c('h3', [_vm._v("CDN")]), _vm._v(" "), _c('p', [_vm._v("https://unpkg.com/vue-circle-slider@1.0.0")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row footer"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h1', [_vm._v("vue-circle-slider")]), _vm._v(" "), _c('div', {}, [_c('a', {
    staticClass: "github-button",
    attrs: {
      "href": "https://github.com/devstark-com/vue-circle-slider/subscription",
      "data-size": "large",
      "data-show-count": "true",
      "aria-label": "Watch devstark-com/vue-circle-slider on GitHub"
    }
  }, [_vm._v("Watch")]), _vm._v(" "), _c('a', {
    staticClass: "github-button",
    attrs: {
      "href": "https://github.com/devstark-com/vue-circle-slider",
      "data-size": "large",
      "data-show-count": "true",
      "aria-label": "Star devstark-com/vue-circle-slider on GitHub"
    }
  }, [_vm._v("Star")]), _vm._v(" "), _c('a', {
    staticClass: "github-button",
    attrs: {
      "href": "https://github.com/devstark-com/vue-circle-slider/archive/master.zip",
      "data-size": "large",
      "aria-label": "Download devstark-com/vue-circle-slider on GitHub"
    }
  }, [_vm._v("Download")]), _vm._v(" "), _c('a', {
    staticClass: "github-button",
    attrs: {
      "href": "https://github.com/devstark-com",
      "data-size": "large",
      "data-show-count": "true",
      "aria-label": "Follow @devstark-com on GitHub"
    }
  }, [_vm._v("Follow")])])])])
}]}

/***/ }),
/* 16 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('hello')], 1)
},staticRenderFns: []}

/***/ }),
/* 17 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 snippet-title",
    attrs: {
      "id": _vm.title
    }
  }, [_c('h3', {
    staticClass: "ex-title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), (_vm.desc) ? _c('h5', {
    staticClass: "ex-desc",
    domProps: {
      "innerHTML": _vm._s(_vm.desc)
    }
  }) : _vm._e(), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "btn btn-default btn-jsfiddle",
    attrs: {
      "href": _vm.fiddlelink,
      "target": "_blank"
    }
  }, [_vm._v("Try it with JSfiddle")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-sm-12 col-xs-12 snippet"
  }, [_c('pre', [_vm._v("\n        "), _c('code', {
    directives: [{
      name: "hljs",
      rawName: "v-hljs"
    }],
    staticClass: "xml",
    domProps: {
      "textContent": _vm._s(_vm.snippet)
    }
  }), _vm._v("\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "demo"
  }, [_vm._t("default")], 2), _vm._v(" "), _vm._t("external")], 2)])
},staticRenderFns: []}

/***/ })
],[6]);


// WEBPACK FOOTER //
// static/js/app.bddaf37a64cbc5f47244.js